// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2muWV","label":"Radio_label__1gZ45","checkMark":"Radio_checkMark__333yh","disabled":"Radio_disabled__319iH"};